import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { enforcesPasswordChange } from '../utils/roles';

/**
 * Role-based default landing redirect.
 *
 * - Unauthenticated           → /login
 * - Platform operator         → /platform          (the operator app)
 * - Customer tiers            → /dashboard          (their tenant workspace)
 * - Legacy Attendee/Delegate  → /my-weekend
 * - Legacy Organizer/Admin    → /dashboard
 */
export function DefaultRedirect() {
  const { user, isAuthenticated, mustChangePassword } = useAuth();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // Staff/operator/customer with a temp password must set it before anything.
  if (mustChangePassword && enforcesPasswordChange(user.role)) {
    return <Navigate to="/change-password" replace />;
  }

  // Platform operators manage tenants from the standalone operator console.
  // Legacy 'Admin' with no tenant is treated as the platform operator too.
  if (user.role === 'PlatformAdmin' || user.role === 'PlatformUser' || user.role === 'Admin') {
    return <Navigate to="/platform" replace />;
  }

  // Customer-tier staff land in their tenant's event-management dashboard.
  if (
    user.role === 'CustomerSuperUser' ||
    user.role === 'CustomerEditor' ||
    user.role === 'CustomerUser'
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  // Legacy KDU roles
  if (user.role === 'Attendee' || user.role === 'Delegate') {
    return <Navigate to="/my-weekend" replace />;
  }
  return <Navigate to="/dashboard" replace />;
}
